<template>
    <div class="box1">
        <div class="title">受理内容</div>
        <div class="supervisorreply">
            <van-field
            placeholder="最多不能超过40个字..."
            type="textarea"
            maxlength="40"
            v-model="remark"
            @input="change"
                />
            <span class="total">{{currentTotal}}/40</span>
        </div>
        <div class="btn">
            <!-- <div class="submit" @click="getSaveOperation('reply')"> -->
            <div class="submit" @click="configSave()">
                <van-button type="primary">督办回复</van-button>
            </div>
            <!-- <div class="savedraft" @click="getSaveOperation('saveReply')"> -->
            <div class="savedraft" @click="save">
                <van-button plain type="default" color="#979595">保存草稿</van-button>
            </div>
        </div>
    </div>
</template>
<script>
    import api from '../../../../service/modules/complaintApis'
    import util from '../../../../utils/common'
    export default {
        data () {
            return {
                currentTotal: 0,
                id: this.$router.currentRoute.query.orderNum,
                orderNum: this.$router.currentRoute.query.orderNum,
                remark: '',
                isback:this.$store.state.complaint.isBackDetail||util.getJsonLocal('isBack'),
                itemList: util.getJsonLocal('item'),
            }
        },
        created () {
            let params={
                "id":this.itemList.id,
            }
            this.getDetailsInfo(params);
        },
        methods: {
            change () {
                this.remark = this.remark.trim();
                this.currentTotal = this.remark.trim().length;
            },
            configSave (value) {
                if (this.remark.trim().length === 0) {
                    this.$Toast('请填写内容');
                    return;
                }
                this.getSaveOperation();
            },
            getDetailsInfo (params) {
                api.worker.displaySuperviseInfo(params).then((res) => {
                    if (res.ret === 0) {
                        this.remark = res.data.replyContent;
                        this.currentTotal = res.data.replyContent.length;
                    }
                })
            },
            save(){
                if (this.remark.trim().length === 0) {
                    this.$Toast('请填写内容');
                    return;
                }
                let params={
                    "id": this.itemList.id,
                    "replyContent": this.remark.trim()
                }
                api.worker.saveSuperviseReply(params).then(res=>{
                    if(res.ret==0){
                        this.$Toast('操作成功');
                        this.$router.back();
                    }

                })
            },
            getSaveOperation () {
                let params={
                    "id": this.itemList.id,
                    "replyContent": this.remark.trim()
                }
                api.worker.superviseReply(params).then((res) => {
                    if (res.ret === 0) {
                        this.$Toast('操作成功');
                        this.$router.back();
                    }
                })
            }
        }
    }
</script>
<style lang="less">
    .box1 {
        width: 100%;
        padding: 14px;
        background-color: #fff;
        .title {
            font-size: 14px;
            color: #999
        }
        .supervisorreply {
            font-size: 14px;
            margin-top: 14px;
            position: relative;
            .van-cell {
                font-size: 14px;
                background: #efeded;
                border-radius: 7px;
            }
            .total{
                    position: absolute;
                    bottom:6px;
                    right:6px;
            }
        }
        .btn {
            margin-top: 30px;
                .van-button {
                    width: 100%;
                    border-radius: 7px;
                    margin-top: 10px;
                }

            .savedraft {
                .van-button {
                    color: #bdb8b8
                }
                .van-button--plain {
                    background-color: #efeded;
                }
            }
        }
    }
</style>
